const state = new WeakMap();

const getRoot = () => document.querySelector('[data-drv-ingl]');

const getState = (root) => {
  if (!state.has(root)) {
    state.set(root, { limit: Number(root.dataset.perLoad) || 12, letter: '', query: '' });
  }
  return state.get(root);
};

const render = (root, announce) => {
  const current = getState(root);
  const items = [...root.querySelectorAll('[data-drv-ingl-grid] > li')];
  const filtering = Boolean(current.letter || current.query);
  let matches = 0;
  items.forEach((item) => {
    const match =
      (!current.letter || item.dataset.letter === current.letter) &&
      (!current.query || (item.dataset.search || '').includes(current.query));
    if (match) matches += 1;
    item.hidden = !match || (!filtering && matches > current.limit);
  });
  const moreWrap = root.querySelector('.drv-ingl__more');
  if (moreWrap) moreWrap.hidden = filtering || current.limit >= items.length;
  const empty = root.querySelector('[data-drv-ingl-empty]');
  if (empty) empty.hidden = matches > 0;
  document.querySelectorAll('[data-drv-ingl-letter]').forEach((button) => {
    button.setAttribute('aria-pressed', String(button.dataset.drvInglLetter === current.letter));
  });
  document.querySelectorAll('[data-drv-ingl-clear]').forEach((button) => {
    button.hidden = !current.query;
  });
  document.querySelectorAll('[data-drv-ingl-search-icon]').forEach((icon) => {
    icon.hidden = Boolean(current.query);
  });
  const status = root.querySelector('[data-drv-ingl-status]');
  if (announce && status) {
    status.textContent = filtering
      ? (root.dataset.matchingText || '').replace('[count]', matches)
      : (root.dataset.showingText || '')
          .replace('[shown]', Math.min(current.limit, items.length))
          .replace('[total]', items.length);
  }
};

const dropQueryParam = () => {
  const url = new URL(window.location.href);
  if (!url.searchParams.has('q')) return;
  url.searchParams.delete('q');
  history.replaceState(history.state, '', url);
};

const showAll = (root) => {
  const current = getState(root);
  current.letter = '';
  current.query = '';
  document.querySelectorAll('[data-drv-ingl-search]').forEach((input) => {
    input.value = '';
  });
  dropQueryParam();
  render(root, true);
  document.querySelector('[data-drv-ingl-search]')?.focus();
};

const showMore = (root, moveFocus) => {
  const current = getState(root);
  const items = [...root.querySelectorAll('[data-drv-ingl-grid] > li')];
  const firstNew = items[current.limit];
  current.limit += Number(root.dataset.perLoad) || 12;
  render(root, true);
  if (moveFocus && firstNew) firstNew.querySelector('a')?.focus();
};

document.addEventListener('click', (event) => {
  const root = getRoot();
  if (!root) return;
  const letterButton = event.target.closest('[data-drv-ingl-letter]');
  if (letterButton) {
    const current = getState(root);
    const value = letterButton.dataset.drvInglLetter;
    current.letter = current.letter === value ? '' : value;
    if (current.letter) {
      current.query = '';
      document.querySelectorAll('[data-drv-ingl-search]').forEach((input) => {
        input.value = '';
      });
      dropQueryParam();
    }
    render(root, true);
    return;
  }
  if (event.target.closest('[data-drv-ingl-clear], [data-drv-ingl-reset]')) {
    event.preventDefault();
    showAll(root);
    return;
  }
  if (event.target.closest('[data-drv-ingl-more]')) showMore(root, event.detail === 0);
});

document.addEventListener('input', (event) => {
  const input = event.target.closest('[data-drv-ingl-search]');
  const root = getRoot();
  if (!input || !root) return;
  const current = getState(root);
  current.query = input.value.trim().toLowerCase();
  if (current.query) current.letter = '';
  dropQueryParam();
  render(root, true);
});

document.addEventListener('submit', (event) => {
  if (event.target.closest('[data-drv-ingl-search-form]')) event.preventDefault();
});

const watchMore = (root) => {
  if (!('drvAuto' in root.dataset) || !('IntersectionObserver' in window)) return;
  const button = root.querySelector('[data-drv-ingl-more]');
  if (!button || button.dataset.drvWatched) return;
  button.dataset.drvWatched = '1';
  const observer = new IntersectionObserver(
    ([entry]) => {
      const current = getState(root);
      if (!entry.isIntersecting || current.letter || current.query) return;
      showMore(root, false);
      observer.unobserve(button);
      if (!button.closest('.drv-ingl__more')?.hidden) observer.observe(button);
    },
    { rootMargin: '0px 0px 400px 0px' }
  );
  observer.observe(button);
};

const init = () => {
  const root = getRoot();
  if (!root) return;
  const query = new URLSearchParams(window.location.search).get('q');
  if (query) {
    getState(root).query = query.trim().toLowerCase();
    document.querySelectorAll('[data-drv-ingl-search]').forEach((input) => {
      input.value = query;
    });
  }
  render(root, false);
  watchMore(root);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
document.addEventListener('shopify:section:load', init);
